(function(){
    var quizzes = document.querySelectorAll('[data-hc-quiz]');
    quizzes.forEach(function(quiz){
      var steps = quiz.querySelectorAll('.hc-quiz__step:not(.hc-quiz__result)');
      var results = quiz.querySelectorAll('.hc-quiz__result');
      var ticks = quiz.querySelectorAll('.hc-quiz__progress-tick');
      var hint = quiz.querySelector('[data-hc-quiz-hint]');
      var backBtn = quiz.querySelector('[data-hc-quiz-back]');
      var progressBar = quiz.querySelector('.hc-quiz__progress');
      var totalSteps = steps.length;
      var current = 0;
      var scores = { first_order: 0, steak_night: 0, freezer_stockup: 0, gift_ready: 0 };
      var history = [];

      function showStep(i){
        steps.forEach(function(s, idx){ s.classList.toggle('is-active', idx === i); });
        results.forEach(function(r){ r.classList.remove('is-active'); });
        ticks.forEach(function(t, idx){
          t.classList.remove('is-active', 'is-done');
          if (idx < i) t.classList.add('is-done');
          else if (idx === i) t.classList.add('is-active');
        });
        if (hint) hint.textContent = 'Step ' + (i + 1) + ' of ' + totalSteps;
        if (backBtn) backBtn.disabled = (i === 0);
        if (progressBar) progressBar.setAttribute('aria-valuenow', String(i + 1));
        current = i;
      }

      function showResult(bucket){
        steps.forEach(function(s){ s.classList.remove('is-active'); });
        var target = null;
        results.forEach(function(r){
          var match = r.getAttribute('data-bucket') === bucket;
          r.classList.toggle('is-active', match);
          if (match) target = r;
        });
        ticks.forEach(function(t){ t.classList.remove('is-active'); t.classList.add('is-done'); });
        if (hint) hint.textContent = 'Your route';
        if (backBtn) backBtn.disabled = false;
        if (target) {
          try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch(e){}
          target.dataset.quizResultBucket = bucket;
        }
      }

      function pickBucket(){
        var best = 'first_order';
        var bestScore = -1;
        Object.keys(scores).forEach(function(k){
          if (scores[k] > bestScore){ bestScore = scores[k]; best = k; }
        });
        return best;
      }

      quiz.addEventListener('click', function(e){
        var ans = e.target.closest('.hc-quiz__answer');
        if (ans && quiz.contains(ans)) {
          var bucket = ans.getAttribute('data-bucket');
          var weight = parseInt(ans.getAttribute('data-weight') || '1', 10);
          if (scores.hasOwnProperty(bucket)) scores[bucket] += weight;
          history.push({ step: current, bucket: bucket, weight: weight });
          ans.classList.add('is-selected');
          setTimeout(function(){
            if (current < totalSteps - 1) {
              ans.classList.remove('is-selected');
              showStep(current + 1);
            } else {
              showResult(pickBucket());
            }
          }, 240);
        }
        var back = e.target.closest('[data-hc-quiz-back]');
        if (back && quiz.contains(back) && !back.disabled) {
          if (history.length === 0) return;
          var last = history.pop();
          if (scores.hasOwnProperty(last.bucket)) scores[last.bucket] -= last.weight;
          showStep(last.step);
        }
        var restart = e.target.closest('[data-hc-quiz-restart]');
        if (restart && quiz.contains(restart)) {
          scores = { first_order: 0, steak_night: 0, freezer_stockup: 0, gift_ready: 0 };
          history = [];
          var allAns = quiz.querySelectorAll('.hc-quiz__answer.is-selected');
          allAns.forEach(function(a){ a.classList.remove('is-selected'); });
          showStep(0);
        }
      });

      // --- Klaviyo email capture on result page ---
      var COMPANY_ID = 'HYkGC5';
      var LIST_ID = 'Ui5E3n';
      quiz.addEventListener('submit', function(e){
        var form = e.target.closest('[data-hc-quiz-signup]');
        if (!form || !quiz.contains(form)) return;
        e.preventDefault();
        var resultEl = form.closest('.hc-quiz__result');
        var bucket = resultEl ? resultEl.getAttribute('data-bucket') : 'unknown';
        var emailInput = form.querySelector('input[type=email]');
        var submitBtn = form.querySelector('button[type=submit]');
        var state = form.querySelector('[data-hc-quiz-state]');
        var email = (emailInput && emailInput.value || '').trim();
        if (!email || email.indexOf('@') < 0) {
          if (state){ state.className = 'hc-quiz__signup-state is-error'; state.textContent = 'Enter a valid email'; }
          return;
        }
        if (state){ state.className = 'hc-quiz__signup-state'; state.textContent = 'Sending...'; }
        if (submitBtn) submitBtn.disabled = true;
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Steak Finder Quiz - Homepage',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      quiz_bucket: bucket,
                      quiz_completed_at: new Date().toISOString(),
                      quiz_source: 'homepage-2026-05-15'
                    }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: LIST_ID } } }
          }
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
          method: 'POST',
          headers: { 'revision': '2024-10-15', 'content-type': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function(r){
          if (r.status === 202 || r.status === 200 || r.status === 201) {
            if (state){ state.className = 'hc-quiz__signup-state is-success'; state.textContent = 'On the list. Look for the welcome email.'; }
            if (emailInput) emailInput.value = '';
          } else {
            return r.text().then(function(t){
              if (state){ state.className = 'hc-quiz__signup-state is-error'; state.textContent = 'Could not subscribe. Try again.'; }
            });
          }
        }).catch(function(){
          if (state){ state.className = 'hc-quiz__signup-state is-error'; state.textContent = 'Network error. Try again.'; }
        }).finally(function(){
          if (submitBtn) submitBtn.disabled = false;
        });
      });

      showStep(0);
    });
  })();